import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./artificialIntelligence.scss"



function ArtificialIntelligence() {
  const { t } = useTranslation()
  return (
    <div className='container-artificial-intelligence'>
      <div className="texts-artificial-intelligence">
        <SectionComponent title={t("industry.artificial_inteligence.title")} text={t("industry.artificial_inteligence.section_text")} />

        <SectionComponent title={t("industry.consulting.title")} text={t("industry.consulting.section_text_1")} >
          <p>{t("industry.consulting.section_text_2")}</p>
          <p>{t("industry.consulting.section_text_3")}</p>
        </SectionComponent>

        <SectionComponent title={t("industry.antifraud.title")} text={t("industry.antifraud.section_text")} />

        <SectionComponent title={t("industry.kpis.title")} text={t("industry.kpis.section_text_1")}>
          <p>{t("industry.kpis.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("industry.workflow.title")} text={t("industry.workflow.section_text_1")} >
          <p>{t("industry.workflow.section_text_2")}</p>
          <p>{t("industry.workflow.section_text_3")}</p>
        </SectionComponent>
      </div>
    </div>
  )
}

export default ArtificialIntelligence